__webpack_require__.p = "https://gloriousfabric.lk/";